export { OffsetRange } from '../core/offsetRange.js';
import { OffsetRange } from '../core/offsetRange.js';

/**
 * A pair of ranges, one in `original`, one in `modified`.
 */
export class OffsetRangeMapping {
	constructor(
		readonly original: OffsetRange,
		readonly modified: OffsetRange,
	) { }

	toString(): string {
		return `${this.original} <-> ${this.modified}`;
	}
}
